import React from "react"
import {shortenNumber} from "../../utils/utils"

export default function TableCell({
  colKey,
  cellData,
  selected,
  className,
  customStyles,
  onCellClick,
  rowData,
}) {
  let tableCellData

  if (colKey === "visits" || colKey === "locations")
    tableCellData = shortenNumber(cellData)
  else tableCellData = cellData

  return (
    <td
      key={colKey}
      align="left"
      data-testid="td"
      style={{...customStyles}}
      className={"cell" + (selected ? "-selected" : "") + " " + className}
      onClick={() => onCellClick && onCellClick(rowData)}
    >
      {tableCellData}
    </td>
  )
}
